import { useEffect, useState } from "react";
import api from "@/lib/api";
import { Trophy, Medal } from "lucide-react";

export default function LeaderboardPage() {
  const [leaders, setLeaders] = useState([]);

  useEffect(() => {
    api.get("/leaderboard").then(r => setLeaders(r.data)).catch(console.error);
  }, []);

  const getRankIcon = (i) => {
    if (i === 0) return <Trophy className="w-4 h-4 text-[#F7941D]" />;
    if (i === 1) return <Medal className="w-4 h-4 text-white/40" />;
    if (i === 2) return <Medal className="w-4 h-4 text-amber-600" />;
    return <span className="font-mono text-xs text-white/25 w-4 text-center inline-block">{i + 1}</span>;
  };

  return (
    <div className="space-y-6 max-w-5xl" data-testid="leaderboard-page">
      <div className="animate-fade-in-up">
        <h1 className="text-2xl sm:text-3xl font-semibold text-white/90 tracking-tight">Leaderboard</h1>
        <p className="text-white/35 text-sm mt-1">Top performing ambassadors</p>
      </div>

      <div className="glass rounded-2xl overflow-hidden animate-fade-in-up" style={{ animationDelay: '60ms' }}>
        <div className="overflow-x-auto">
          <table className="w-full">
            <thead>
              <tr className="border-b border-white/[0.06]">
                <th className="text-left text-white/35 text-xs font-medium py-3 px-5 w-16">Rank</th>
                <th className="text-left text-white/35 text-xs font-medium py-3 px-5">Ambassador</th>
                <th className="text-right text-white/35 text-xs font-medium py-3 px-5">Points</th>
                <th className="text-right text-white/35 text-xs font-medium py-3 px-5">Clicks</th>
                <th className="text-right text-white/35 text-xs font-medium py-3 px-5">Signups</th>
                <th className="text-right text-white/35 text-xs font-medium py-3 px-5">Earnings</th>
              </tr>
            </thead>
            <tbody>
              {leaders.map((l, i) => (
                <tr key={i} className="border-b border-white/[0.03] last:border-0 hover:bg-white/[0.02] transition-colors duration-200" data-testid={`leaderboard-row-${i}`}>
                  <td className="py-3 px-5 w-16">{getRankIcon(i)}</td>
                  <td className="py-3 px-5">
                    <div className="flex items-center gap-3">
                      <div className="w-7 h-7 rounded-full bg-[#F7941D]/10 flex items-center justify-center text-xs font-semibold text-[#F7941D]">
                        {l.name?.[0]?.toUpperCase()}
                      </div>
                      <span className="text-sm font-medium text-white/75">{l.name}</span>
                    </div>
                  </td>
                  <td className="font-mono text-sm text-right text-purple-400 font-medium py-3 px-5">{l.points}</td>
                  <td className="font-mono text-sm text-right text-blue-400 py-3 px-5">{l.total_clicks}</td>
                  <td className="font-mono text-sm text-right text-green-400 py-3 px-5">{l.total_signups}</td>
                  <td className="font-mono text-sm text-right text-[#F7941D] font-medium py-3 px-5">${(l.total_earnings || 0).toFixed(2)}</td>
                </tr>
              ))}
              {leaders.length === 0 && (
                <tr>
                  <td colSpan={6} className="text-center text-white/25 py-12">No ambassadors on the leaderboard yet</td>
                </tr>
              )}
            </tbody>
          </table>
        </div>
      </div>
    </div>
  );
}
